import classNames from 'classnames';
import './spacer.scss';

export default function Spacer({ size = 'm' }) {
  return <div className={classNames('spacer', `spacer--${size}`)} />;
}
